<template>
  <section>
    <sc-chart :options="chartData" />
  </section>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { ScChart } from '@intelipost-js/secure-components';

  const { mapState, mapGetters } = createNamespacedHelpers('analytic/deliveredProvider');

  export default {
    name: 'sc-report-delivered-provider-chart',
    computed: {
      ...mapState([
        'chartData',
      ]),
      ...mapGetters([
        'reportChartDates',
        'reportChartSeries',
      ]),
      chartData() {
        return {
          title: {
            text: '',
          },
          yAxis: {
            title: {
              text: '',
            },
          },
          xAxis: {
            categories: this.reportChartDates,
          },
          tooltip: {
            backgroundColor: 'white',
            useHTML: true,
            headerFormat: '<h3 style="margin-bottom: 0.5rem;">{point.key}</h3>',
            pointFormat: '<span style="color:{series.color};font-weight:bold;">{series.name}: {point.y}</span><br/>',
            shared: true,
          },

          series: this.reportChartSeries,
        };
      },
    },
    components: {
      ScChart,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/delivered-provider/components/sc-report-delivered-provider-chart/ScReportDeliveredProviderChart.vue